import { AlertTitleProps as ChakraAlertTitleProps } from '@chakra-ui/react-v2';
import { chakra, forwardRef } from '@chakra-ui/system';
import { cx } from '@chakra-ui/utils';

import { useAlertContext, useAlertStyles } from './utils/AlertContext';

export type AlertTitleProps = ChakraAlertTitleProps;

export const AlertTitle = forwardRef<AlertTitleProps, 'div'>(
  function AlertTitle(props, ref) {
    const styles = useAlertStyles();
    const { status } = useAlertContext();

    return (
      <chakra.div
        ref={ref}
        data-status={status}
        {...props}
        className={cx('chakra-alert__title', props.className)}
        __css={styles.title}
      />
    );
  },
);

AlertTitle.displayName = 'AlertTitle';
